export const decimalToTime = (num: number) =>
  ('0' + (Math.floor(num) % 24)).slice(-2) + ':' + ((num % 1) * 60 + '0').slice(0, 2);
